import React from "react"

import {AppSitesAutocomplete} from "@components"
import {useUserSettingsSitesGroup, useUserSettingsSitesGroupValidator} from "../../@hooks"
import { userSettingsSitesGroupFormData } from "../../@signals"

export default function UserSettingSitesGroupDrawerSites() {
    const { handleChangeSitesGroupFormData } = useUserSettingsSitesGroup()
    const { sitesError } = useUserSettingsSitesGroupValidator()

    return <AppSitesAutocomplete
        multiple
        placeholder="Select site(s)"
        error={sitesError}
        value={userSettingsSitesGroupFormData.value?.sites || []}
        onChange={e => handleChangeSitesGroupFormData(e.target.value, 'sites')}
    />
}